export default __webpack_public_path__ + "static/media/689.8460f333.png";